module.exports = __webpack_public_path__ + "img/sph.1311aca6.jpg";